import { datadogLogs } from '@datadog/browser-logs';
import { CognitoUserSession } from 'amazon-cognito-identity-js';
import { AuthSession, fetchAuthSession } from 'aws-amplify/auth';

import { getErrorMessage } from 'utils/datadog';

import { userPool } from './cognito';

const getSessionCallback = (err: Error | void, session: CognitoUserSession | null) => {
  if (err) {
    datadogLogs.logger.error('Failed to get cognito session', { error: getErrorMessage(err) });
  }
  return session;
};

export const getCurrentUserSession = async (
  signOut?: () => void,
): Promise<CognitoUserSession | AuthSession | null> => {
  const currentUser = userPool.getCurrentUser();

  if (!currentUser) {
    try {
      const session = await fetchAuthSession();
      if (session.tokens) {
        return session;
      }
      return null;
    } catch (error) {
      return null;
    }
  }

  const cognitoUserSession: CognitoUserSession | null | undefined = await new Promise((resolve) =>
    currentUser.getSession((...args: Parameters<typeof getSessionCallback>) =>
      resolve(getSessionCallback(...args)),
    ),
  );

  if (cognitoUserSession) {
    return cognitoUserSession;
  }

  signOut?.();
  return null;
};
